import type { Asset } from '@schibsted-svp/svp-api-types';
import type { StreamProvider } from '@vgtv/api-client';
import { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';
import { ComponentChild } from 'preact';

import type { PlayerContext } from '../../../../types/global';

import { PaywallLayoutLabel } from './PaywallLayoutLabel';
import { PaywallButtonsWrapper } from './PaywallButtonsWrapper';
import { AssetTitleContainer } from './AssetTitleContainer';
import { useConfig } from '../../hooks/ConfigProvider';
import { useTitleOverride } from '../../hooks/useTitleOverride';

export const NoAccessState = ({
  label,
  asset,
  isMobile,
  accessLevel,
  context,
}: {
  label?: string | ComponentChild;
  asset?: Asset;
  isMobile: boolean;
  accessLevel?: ProviderAccessMap[StreamProvider];
  context: PlayerContext;
}) => {
  const { ui = {} } = useConfig();
  const titleOverride = useTitleOverride(asset);

  return (
    <div className="vgp-no-access-state-container-sport">
      <div className="vgp-has-access-top">
        <div className="vgp-has-access-top-left"></div>
        <div className="vgp-has-access-top-right">
          {label && (
            <PaywallLayoutLabel
              accessLevel={accessLevel}
              hasAccess={false}
              label={label}
              isMobile={isMobile}
            />
          )}
        </div>
      </div>
      {!isMobile && <div className="vgp-has-access-center"></div>}
      <div className="vgp-has-access-bottom">
        {!ui.hideTitle && (
          <AssetTitleContainer
            asset={asset}
            context={context}
            titleOverride={titleOverride}
          />
        )}
        <div className="vgp-container-sport">
          {asset && (
            <PaywallButtonsWrapper
              accessLevel={accessLevel}
              asset={asset}
              isMobile={isMobile}
            />
          )}
        </div>
      </div>
    </div>
  );
};
